import React from 'react';
 
const PrivacyPolicy = () => {
  return (
    
    <>
    <meta content="text/html; charset=UTF-8" httpEquiv="content-type" />
    <style
      type="text/css"
      dangerouslySetInnerHTML={{
        __html:
          '\n        ul.lst-kix_203agmb87iff-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-8 {\n            list-style-type: none\n        }\n\n        .lst-kix_gkhwnxymdnq8-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_u4p1gsny45dp-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_u4p1gsny45dp-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_u4p1gsny45dp-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_u4p1gsny45dp-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_u4p1gsny45dp-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gkhwnxymdnq8-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-5 {\n            list-style-type: none\n        }\n\n        .lst-kix_u4p1gsny45dp-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_u4p1gsny45dp-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_t4h5h7bcvu2m-1 {\n            list-style-type: none\n        }\n\n        .lst-kix_u4p1gsny45dp-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gvly85ymwvkx-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-7 {\n            list-style-type: none\n        }\n\n        .lst-kix_gvly85ymwvkx-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gvly85ymwvkx-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_t4h5h7bcvu2m-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-1 {\n            list-style-type: none\n        }\n\n        .lst-kix_t4h5h7bcvu2m-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gkhwnxymdnq8-5 {\n            list-style-type: none\n        }\n\n        .lst-kix_t4h5h7bcvu2m-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_qun6ib82ymdy-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_qun6ib82ymdy-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_jllwi7q46po9-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_jllwi7q46po9-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_qun6ib82ymdy-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_jllwi7q46po9-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_qun6ib82ymdy-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_qun6ib82ymdy-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_qun6ib82ymdy-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_jllwi7q46po9-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_jllwi7q46po9-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_qun6ib82ymdy-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_jllwi7q46po9-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_jllwi7q46po9-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_jllwi7q46po9-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_jllwi7q46po9-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_203agmb87iff-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_203agmb87iff-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_203agmb87iff-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_203agmb87iff-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        ul.lst-kix_qun6ib82ymdy-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-2 {\n            list-style-type: none\n        }\n\n        .lst-kix_203agmb87iff-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_203agmb87iff-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_qun6ib82ymdy-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-6 {\n            list-style-type: none\n        }\n\n        .lst-kix_qun6ib82ymdy-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        ul.lst-kix_qun6ib82ymdy-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_qun6ib82ymdy-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-2 {\n            list-style-type: none\n        }\n\n        .lst-kix_qun6ib82ymdy-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_gvly85ymwvkx-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_gvly85ymwvkx-0 {\n            list-style-type: none\n        }\n\n        .lst-kix_gvly85ymwvkx-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        ul.lst-kix_gvly85ymwvkx-1 {\n            list-style-type: none\n        }\n\n        .lst-kix_m6xusvgx48ir-0>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_203agmb87iff-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_gvly85ymwvkx-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_203agmb87iff-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_203agmb87iff-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_gvly85ymwvkx-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gvly85ymwvkx-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_gvly85ymwvkx-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_gvly85ymwvkx-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_m6xusvgx48ir-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_m6xusvgx48ir-7>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_m6xusvgx48ir-6>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_m6xusvgx48ir-4>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_m6xusvgx48ir-3>li:before {\n            content: "\\0025cf   "\n        }\n\n        .lst-kix_m6xusvgx48ir-5>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_m6xusvgx48ir-1>li:before {\n            content: "\\0025cb   "\n        }\n\n        .lst-kix_m6xusvgx48ir-2>li:before {\n            content: "\\0025a0   "\n        }\n\n        .lst-kix_u4p1gsny45dp-8>li:before {\n            content: "\\0025a0   "\n        }\n\n        ul.lst-kix_gvly85ymwvkx-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_m6xusvgx48ir-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_u4p1gsny45dp-3 {\n            list-style-type: none\n        }\n\n        li.li-bullet-0:before {\n            margin-left: -18pt;\n            white-space: nowrap;\n            display: inline-block;\n            min-width: 18pt\n        }\n\n        ul.lst-kix_u4p1gsny45dp-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-7 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-8 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-2 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-3 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-4 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-0 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-5 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-1 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_203agmb87iff-6 {\n            list-style-type: none\n        }\n\n        ul.lst-kix_jllwi7q46po9-2 {\n            list-style-type: none\n        }\n\n        ol {\n            margin: 0;\n            padding: 0\n        }\n\n        table td,\n        table th {\n            padding: 0\n        }\n\n        .c3 {\n            margin-left: 36pt;\n            padding-top: 12pt;\n            padding-left: 0pt;\n            padding-bottom: 24pt;\n            line-height: 1.15;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .c10 {\n            color: #000000;\n            font-weight: 700;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 18pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c2 {\n            color: #000000;\n            font-weight: 700;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 24pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c0 {\n            color: #000000;\n            font-weight: 400;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 12pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c11 {\n            padding-top: 0pt;\n            padding-bottom: 0pt;\n            line-height: 1.15;\n            orphans: 2;\n            widows: 2;\n            text-align: left;\n            height: 11pt\n        }\n\n        .c15 {\n            color: #000000;\n            font-weight: 400;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 11pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c6 {\n            color: #000000;\n            font-weight: 700;\n            text-decoration: none;\n            vertical-align: baseline;\n            font-size: 30pt;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c1 {\n            padding-top: 0pt;\n            padding-bottom: 12pt;\n            line-height: 1.15;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .c7 {\n            padding-top: 0pt;\n            padding-bottom: 12pt;\n            line-height: 1.5;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .c16 {\n            font-weight: 400;\n            vertical-align: baseline;\n            font-family: "Arial";\n            font-style: normal\n        }\n\n        .c14 {\n            text-decoration-skip-ink: none;\n            -webkit-text-decoration-skip: none;\n            color: #553df4;\n            text-decoration: underline\n        }\n\n        .c12 {\n            background-color: #ffffff;\n            max-width: 451.3pt;\n            padding: 72pt 72pt 72pt 72pt\n        }\n\n        .c4 {\n            font-size: 12pt;\n            font-weight: 700\n        }\n\n        .c9 {\n            color: inherit;\n            text-decoration: inherit\n        }\n\n        .c13 {\n            background-color: #ffffff;\n            font-size: 10.5pt\n        }\n\n        .c8 {\n            padding: 0;\n            margin: 0\n        }\n\n        .c5 {\n            font-size: 12pt\n        }\n\n        .title {\n            padding-top: 0pt;\n            color: #000000;\n            font-size: 26pt;\n            padding-bottom: 3pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        .subtitle {\n            padding-top: 0pt;\n            color: #666666;\n            font-size: 15pt;\n            padding-bottom: 16pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        li {\n            color: #000000;\n            font-size: 11pt;\n            font-family: "Arial"\n        }\n\n        p {\n            margin: 0;\n            color: #000000;\n            font-size: 11pt;\n            font-family: "Arial"\n        }\n\n        h1 {\n            padding-top: 20pt;\n            color: #000000;\n            font-size: 20pt;\n            padding-bottom: 6pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h2 {\n            padding-top: 18pt;\n            color: #000000;\n            font-size: 16pt;\n            padding-bottom: 6pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h3 {\n            padding-top: 16pt;\n            color: #434343;\n            font-size: 14pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h4 {\n            padding-top: 14pt;\n            color: #666666;\n            font-size: 12pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h5 {\n            padding-top: 12pt;\n            color: #666666;\n            font-size: 11pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n\n        h6 {\n            padding-top: 12pt;\n            color: #666666;\n            font-size: 11pt;\n            padding-bottom: 4pt;\n            font-family: "Arial";\n            line-height: 1.15;\n            page-break-after: avoid;\n            font-style: italic;\n            orphans: 2;\n            widows: 2;\n            text-align: left\n        }\n    '
      }}
    />
    <h1 className="c7" id="h.m83e469s64we">
      <span className="c6">Privacy Policy</span>
    </h1>
    <p className="c1">
      <span className="c0">Last updated: June 18, 2023</span>
    </p>
    <p className="c1">
      <span className="c0">
        This Privacy Policy describes Our policies and procedures on the
        collection, use and disclosure of Your information when You use the
        Service and tells You about Your privacy rights and how the law protects
        You.
      </span>
    </p>
    <p className="c1">
      <span className="c5">
        We use Your Personal data to provide and improve the Service. By using the
        Service, You agree to the collection and use of information in accordance
        with this Privacy Policy. This Privacy Policy has been created with the
        help of the{" "}
      </span>
      <span className="c5">
        <a
          className="c9"
          href="https://www.google.com/url?q=https://www.freeprivacypolicy.com/free-privacy-policy-generator/&sa=D&source=editors&ust=1687199302029712&usg=AOvVaw06EXG9HNFrYaeaI_bfubXh"
        >
          Free Privacy Policy Generator
        </a>
      </span>
      <span className="c0">.</span>
    </p>
    <h1 className="c7" id="h.erl2sjoksy1a">
      <span className="c6">Interpretation and Definitions</span>
    </h1>
    <h2 className="c7" id="h.zghzco6e3w0t">
      <span className="c2">Interpretation</span>
    </h2>
    <p className="c1">
      <span className="c0">
        The words of which the initial letter is capitalized have meanings defined
        under the following conditions. The following definitions shall have the
        same meaning regardless of whether they appear in singular or in plural.
      </span>
    </p>
    <h2 className="c7" id="h.xp07dkd4sdje">
      <span className="c2">Definitions</span>
    </h2>
    <p className="c1">
      <span className="c0">For the purposes of this Privacy Policy:</span>
    </p>
    <ul className="c8 lst-kix_203agmb87iff-0 start">
      <li className="c3 li-bullet-0">
        <span className="c4">Account</span>
        <span className="c0">
          &nbsp;means a unique account created for You to access our Service or
          parts of our Service.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Affiliate</span>
        <span className="c0">
          &nbsp;means an entity that controls is controlled by or is under common
          control with a party, where "control" means ownership of 50% or more of
          the shares, equity interest or other securities entitled to vote for
          election of directors or other managing authority.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Company</span>
        <span className="c5">
          &nbsp;(referred to as either "the Company", "We", "Us" or "Our" in this
          Agreement) refers to
        </span>
        <span className="c13">ONE UPGRADING TEXTBOOKS (OPC) PRIVATE LIMITED</span>
        <span className="c0">, Bihar, India.</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Cookies</span>
        <span className="c0">
          &nbsp;are small files that are placed on Your computer, mobile device or
          any other device by a website, containing the details of Your browsing
          history on that website among its many uses.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Country</span>
        <span className="c0">&nbsp;refers to: Bihar, India</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Device</span>
        <span className="c0">
          &nbsp;means any device that can access the Service such as a computer, a
          cellphone, or a digital tablet.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Personal Data</span>
        <span className="c0">
          &nbsp;is any information that relates to an identified or identifiable
          individual.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Service</span>
        <span className="c0">&nbsp;refers to the Website.</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Service Provider</span>
        <span className="c0">
          &nbsp;means any natural or legal person who processes the data on behalf
          of the Company. It refers to third-party companies or individuals
          employed by the Company to facilitate the Service, to provide the
          Service on behalf of the Company, to perform services related to the
          Service, or to assist the Company in analyzing how the Service is used.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Usage Data</span>
        <span className="c0">
          &nbsp;refers to data collected automatically, either generated by the
          use of the Service or from the Service infrastructure itself (for
          example, the duration of a page visit).
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">The website</span>
        <span className="c5">&nbsp;refers to learnwithone, accessible from </span>
        <span className="c5 c14">
          <a
            className="c9"
            href="https://www.google.com/url?q=https://www.learnwithone.com/&sa=D&source=editors&ust=1687199302031739&usg=AOvVaw2S-FuAQYCpmhUJRrF29oY_"
          >
            https://www.learnwithone.co
          </a>
        </span>
        <span className="c14 c5 c16">.in </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">You</span>
        <span className="c0">
          &nbsp;mean the individual accessing or using the Service, or the
          company, or other legal entity on behalf of which such individual is
          accessing or using the Service, as applicable.
        </span>
      </li>
    </ul>
    <h1 className="c7" id="h.frveytvh8wn5">
      <span className="c6">Collecting and Using Your Personal Data</span>
    </h1>
    <h2 className="c7" id="h.brxaoxkevefj">
      <span className="c2">Types of Data Collected</span>
    </h2>
    <h3 className="c7" id="h.uwjaa1hn4aq7">
      <span className="c10">Personal Data</span>
    </h3>
    <p className="c1">
      <span className="c0">
        While using Our Service, We may ask You to provide Us with certain
        personally identifiable information that can be used to contact or
        identify You. Personally identifiable information may include, but is not
        limited to:
      </span>
    </p>
    <ul className="c8 lst-kix_gvly85ymwvkx-0 start">
      <li className="c3 li-bullet-0">
        <span className="c0">Email address</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">First name and last name</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">Phone number</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">
          Address, State, Province, ZIP/Postal code, City
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">Usage Data</span>
      </li>
    </ul>
    <h3 className="c7" id="h.fn9rcbnwr7v9">
      <span className="c10">Usage Data</span>
    </h3>
    <p className="c1">
      <span className="c0">
        Usage Data is collected automatically when using the Service.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        Usage Data may include information such as Your Device's Internet Protocol
        address (e.g. IP address), browser type, browser version, the pages of our
        Service that You visit, the time and date of Your visit, the time spent on
        those pages, unique device identifiers and other diagnostic data.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        When You access the Service by or through a mobile device, We may collect
        certain information automatically, including, but not limited to, the type
        of mobile device You use, Your mobile device unique ID, the IP address of
        Your mobile device, Your mobile operating system, the type of mobile
        Internet browser You use, unique device identifiers and other diagnostic
        data.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        We may also collect information that Your browser sends whenever You visit
        our Service or when You access the Service by or through a mobile device.
      </span>
    </p>
    <h3 className="c7" id="h.887dpr4oa9zt">
      <span className="c10">Tracking Technologies and Cookies</span>
    </h3>
    <p className="c1">
      <span className="c0">
        We use Cookies and similar tracking technologies to track the activity on
        Our Service and store certain information. Tracking technologies used are
        beacons, tags, and scripts to collect and track information and to improve
        and analyze Our Service. The technologies We use may include:
      </span>
    </p>
    <ul className="c8 lst-kix_m6xusvgx48ir-0 start">
      <li className="c3 li-bullet-0">
        <span className="c4">Cookies or Browser Cookies.</span>
        <span className="c0">
          &nbsp;A cookie is a small file placed on Your Device. You can instruct
          Your browser to refuse all Cookies or to indicate when a Cookie is being
          sent. However, if You do not accept Cookies, You may not be able to use
          some parts of our Service. Unless you have adjusted Your browser setting
          so that it will refuse Cookies, our Service may use Cookies.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">Web Beacons.</span>
        <span className="c0">
          &nbsp;Certain sections of our Service and our emails may contain small
          electronic files known as web beacons (also referred to as clear gifs,
          pixel tags, and single-pixel gifs) that permit the Company, for example,
          to count users who have visited those pages or opened an email and for
          other related website statistics (for example, recording the popularity
          of a certain section and verifying system and server integrity).
        </span>
      </li>
    </ul>
    <p className="c1">
      <span className="c5">
        Cookies can be "Persistent" or "Session" Cookies. Persistent Cookies
        remain on Your personal computer or mobile device when You go offline,
        while Session Cookies are deleted as soon as You close Your web browser.
        Learn more about cookies on the{" "}
      </span>
      <span className="c5">
        <a
          className="c9"
          href="https://www.google.com/url?q=https://www.freeprivacypolicy.com/blog/sample-privacy-policy-template/%23Use_Of_Cookies_And_Tracking&sa=D&source=editors&ust=1687199302033846&usg=AOvVaw1rbDfzR-uT6Az-4EcwaIki"
        >
          Free Privacy Policy website
        </a>
      </span>
      <span className="c0">article.</span>
    </p>
    <p className="c1">
      <span className="c0">
        We use both Session and Persistent Cookies for the purposes set out below:
      </span>
    </p>
    <ul className="c8 lst-kix_jllwi7q46po9-0 start">
      <li className="c3 li-bullet-0">
        <span className="c4">
          Necessary / Essential Cookies
          <br />
        </span>
        <span className="c0">
          Type: Session Cookies
          <br />
          Administered by: Us
          <br />
          Purpose: These Cookies are essential to provide You with services
          available through the Website and to enable You to use some of its
          features. They help to authenticate users and prevent fraudulent use of
          user accounts. Without these Cookies, the services that You have asked
          for cannot be provided, and We only use these Cookies to provide You
          with those services.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">
          Cookies Policy / Notice Acceptance Cookies
          <br />
        </span>
        <span className="c0">
          Type: Persistent Cookies
          <br />
          Administered by: Us
          <br />
          Purpose: These Cookies identify if users have accepted the use of
          cookies on the Website.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">
          Functionality Cookies
          <br />
        </span>
        <span className="c0">
          Type: Persistent Cookies
          <br />
          Administered by: Us
          <br />
          Purpose: These Cookies allow us to remember choices You make when You
          use the Website, such as remembering your login details or language
          preference. The purpose of these Cookies is to provide You with a more
          personal experience and to avoid You having to re-enter your preferences
          every time You use the Website.
        </span>
      </li>
    </ul>
    <p className="c1">
      <span className="c0">
        For more information about the cookies we use and your choices regarding
        cookies, please visit our Cookies Policy or the Cookies section of our
        Privacy Policy.
      </span>
    </p>
    <h2 className="c7" id="h.4us0aol4xa0d">
      <span className="c2">Use of Your Personal Data</span>
    </h2>
    <p className="c1">
      <span className="c0">
        The Company may use Personal Data for the following purposes:
      </span>
    </p>
    <ul className="c8 lst-kix_u4p1gsny45dp-0 start">
      <li className="c3 li-bullet-0">
        <span className="c4">To provide and maintain our Service</span>
        <span className="c0">
          , including to monitor the usage of our Service.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">To manage Your Account:</span>
        <span className="c0">
          &nbsp;to manage Your registration as a user of the Service. The Personal
          Data You provide can give You access to different functionalities of the
          Service that are available to You as a registered user.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">For the performance of a contract:</span>
        <span className="c0">
          &nbsp;the development, compliance and undertaking of the purchase
          contract for the products, items or services You have purchased or of
          any other contract with Us through the Service.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">To contact You:</span>
        <span className="c0">
          &nbsp;To contact You by email, telephone calls, SMS, or other equivalent
          forms of electronic communication, such as a mobile application's push
          notifications regarding updates or informative communications related to
          the functionalities, products or contracted services, including the
          security updates, when necessary or reasonable for their implementation.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">To provide You</span>
        <span className="c0">
          &nbsp;with news, special offers and general information about other
          goods, services and events which we offer that are similar to those that
          you have already purchased or enquired about unless You have opted not
          to receive such information.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">To manage Your requests:</span>
        <span className="c0">
          &nbsp;To attend and manage Your requests to Us.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">For business transfers:</span>
        <span className="c0">
          &nbsp;We may use Your information to evaluate or conduct a merger,
          divestiture, restructuring, reorganization, dissolution, or other sale
          or transfer of some or all of Our assets, whether as a going concern or
          as part of bankruptcy, liquidation, or similar proceeding, in which
          Personal Data held by Us about our Service users is among the assets
          transferred.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">For other purposes</span>
        <span className="c0">
          : We may use Your information for other purposes, such as data analysis,
          identifying usage trends, determining the effectiveness of our
          promotional campaigns and to evaluate and improve our Service, products,
          services, marketing and your experience.
        </span>
      </li>
    </ul>
    <p className="c1">
      <span className="c0">
        We may share Your personal information in the following situations:
      </span>
    </p>
    <ul className="c8 lst-kix_qun6ib82ymdy-0 start">
      <li className="c3 li-bullet-0">
        <span className="c4">With Service Providers:</span>
        <span className="c0">
          &nbsp;We may share Your personal information with Service Providers to
          monitor and analyze the use of our Service, to contact You.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">For business transfers:</span>
        <span className="c0">
          &nbsp;We may share or transfer Your personal information in connection
          with, or during negotiations of, any merger, sale of Company assets,
          financing, or acquisition of all or a portion of Our business to another
          company.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">With Affiliates:</span>
        <span className="c0">
          &nbsp;We may share Your information with Our affiliates, in which case
          we will require those affiliates to honor this Privacy Policy.
          Affiliates include Our parent company and any other subsidiaries, joint
          venture partners or other companies that We control or that are under
          common control with Us.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">With business partners:</span>
        <span className="c0">
          &nbsp;We may share Your information with Our business partners to offer
          You certain products, services or promotions.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">With other users:</span>
        <span className="c0">
          &nbsp;when You share personal information or otherwise interact in the
          public areas with other users, such information may be viewed by all
          users and may be publicly distributed outside.
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c4">With Your consent</span>
        <span className="c0">
          : We may disclose Your personal information for any other purpose with
          Your consent.
        </span>
      </li>
    </ul>
    <h2 className="c7" id="h.yrixazjuyxp7">
      <span className="c2">Retention of Your Personal Data</span>
    </h2>
    <p className="c1">
      <span className="c0">
        The Company will retain Your Personal Data only for as long as is
        necessary for the purposes set out in this Privacy Policy. We will retain
        and use Your Personal Data to the extent necessary to comply with our
        legal obligations (for example, if we are required to retain your data to
        comply with applicable laws), resolve disputes, and enforce our legal
        agreements and policies.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        The Company will also retain Usage Data for internal analysis purposes.
        Usage Data is generally retained for a shorter period of time, except when
        this data is used to strengthen the security or to improve the
        functionality of Our Service, or We are legally obligated to retain this
        data for longer time periods.
      </span>
    </p>
    <h2 className="c7" id="h.vnkahkunrdxv">
      <span className="c2">Transfer of Your Personal Data</span>
    </h2>
    <p className="c1">
      <span className="c0">
        Your information, including Personal Data, is processed at the Company's
        operating offices and in any other places where the parties involved in
        the processing are located. It means that this information may be
        transferred to — and maintained on — computers located outside of Your
        state, province, country or other governmental jurisdiction where the data
        protection laws may differ than those from Your jurisdiction.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        Your consent to this Privacy Policy followed by Your submission of such
        information represents Your agreement to that transfer.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        The Company will take all steps reasonably necessary to ensure that Your
        data is treated securely and in accordance with this Privacy Policy and no
        transfer of Your Personal Data will take place to an organization or a
        country unless there are adequate controls in place including the security
        of Your data and other personal information.
      </span>
    </p>
    <h2 className="c7" id="h.x2bgdb4dmhby">
      <span className="c2">Delete Your Personal Data</span>
    </h2>
    <p className="c1">
      <span className="c0">
        You have the right to delete or request that We assist in deleting the
        Personal Data that We have collected about You.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        Our Service may give You the ability to delete certain information about
        You from within the Service.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        You may update, amend, or delete Your information at any time by signing
        in to Your Account if you have one, and visiting the account settings
        section that allows you to manage Your personal information. You may also
        contact Us to request access to, correct, or delete any personal
        information you provided.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        Please note, however, that We may need to retain certain information when
        we have a legal obligation or lawful basis to do so.
      </span>
    </p>
    <h2 className="c7" id="h.jcyzho30cc1s">
      <span className="c2">Disclosure of Your Personal Data</span>
    </h2>
    <h3 className="c7" id="h.ed07jh76ovas">
      <span className="c10">Business Transactions</span>
    </h3>
    <p className="c1">
      <span className="c0">
        If the Company is involved in a merger, acquisition or asset sale, Your
        Personal Data may be transferred. We will provide notice before Your
        Personal Data is transferred and becomes subject to a different Privacy
        Policy.
      </span>
    </p>
    <h3 className="c7" id="h.4351tbcq2o9r">
      <span className="c10">Law enforcement</span>
    </h3>
    <p className="c1">
      <span className="c0">
        Under certain circumstances, the Company may be required to disclose Your
        Personal Data if required to do so by law or in response to valid requests
        by public authorities (e.g. a court or a government agency).
      </span>
    </p>
    <p className="c1">
      <span className="c10">Other legal requirements</span>
    </p>
    <p className="c1">
      <span className="c0">
        The Company may disclose Your Personal Data in the good faith belief that
        such action is necessary to:
      </span>
    </p>
    <ul className="c8 lst-kix_gkhwnxymdnq8-0 start">
      <li className="c3 li-bullet-0">
        <span className="c0">Comply with a legal obligation</span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">
          Protect and defend the rights or property of the Company
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">
          Prevent or investigate possible wrongdoing in connection with the
          Service
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">
          Protect the personal safety of Users of the Service or the public
        </span>
      </li>
      <li className="c3 li-bullet-0">
        <span className="c0">Protect against legal liability</span>
      </li>
    </ul>
    <h2 className="c7" id="h.os6ijvp7rq6t">
      <span className="c2">Security of Your Personal Data</span>
    </h2>
    <p className="c1">
      <span className="c0">
        The security of Your Personal Data is important to Us, but remember that
        no method of transmission over the Internet, or method of electronic
        storage is 100% secure. While We strive to use commercially acceptable
        means to protect Your Personal Data, We cannot guarantee its absolute
        security.
      </span>
    </p>
    <h1 className="c7" id="h.nfbkzediicv1">
      <span className="c6">Children's Privacy</span>
    </h1>
    <p className="c1">
      <span className="c0">
        Our Service does not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from anyone under
        the age of 13. If You are a parent or guardian and You are aware that Your
        child has provided Us with Personal Data, please contact Us. If We become
        aware that We have collected Personal Data from anyone under the age of 13
        without verification of parental consent, We take steps to remove that
        information from Our servers.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        If We need to rely on consent as a legal basis for processing Your
        information and Your country requires consent from a parent, We may
        require Your parent's consent before We collect and use that information.
      </span>
    </p>
    <h1 className="c7" id="h.dsrqvaqte3l">
      <span className="c6">Links to Other Websites</span>
    </h1>
    <p className="c1">
      <span className="c0">
        Our Service may contain links to other websites that are not operated by
        Us. If You click on a third party link, You will be directed to that third
        party's site. We strongly advise You to review the Privacy Policy of every
        site You visit.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        We have no control over and assume no responsibility for the content,
        privacy policies or practices of any third party sites or services.
      </span>
    </p>
    <h1 className="c7" id="h.9sp9ww2mvk4u">
      <span className="c6">Changes to this Privacy Policy</span>
    </h1>
    <p className="c1">
      <span className="c0">
        We may update Our Privacy Policy from time to time. We will notify You of
        any changes by posting the new Privacy Policy on this page.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        We will let You know via email and/or a prominent notice on Our Service,
        prior to the change becoming effective and update the "Last updated" date
        at the top of this Privacy Policy.
      </span>
    </p>
    <p className="c1">
      <span className="c0">
        You are advised to review this Privacy Policy periodically for any
        changes. Changes to this Privacy Policy are effective when they are posted
        on this page.
      </span>
    </p>
    <h1 className="c7" id="h.kjeo3pk4mv4">
      <span className="c6">Contact Us</span>
    </h1>
    <p className="c1">
      <span className="c0">
        If you have any questions about this Privacy Policy, You can contact us:
      </span>
    </p>
    <ul className="c8 lst-kix_t4h5h7bcvu2m-0 start">
      <li className="c3 li-bullet-0">
        <span className="c0">By email: team@learnwithone.co.in</span>
      </li>
    </ul>
    <p className="c11">
      <span className="c15" />
    </p>
  </>
  
  
  );
}

export default PrivacyPolicy;
